import React from 'react';
import { Card, CardHeader, CardBody, Row, Col } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import { formatCurrency } from '../../../helpers/format';

const WalletMetrics = ({ t, summary, isLoading }) => {
  const balance = summary?.balance ?? 0;
  const lastContributionAmount = summary?.last_contribution?.amount ?? 0;
  const totalDebits = summary?.total_debits ?? 0;
  const debitCount = summary?.debit_count ?? 0;
  const lastContributionDate = summary?.last_contribution?.date;

  const balancePercentage =
    lastContributionAmount > 0
      ? ((balance / lastContributionAmount) * 100).toFixed(1)
      : '0.0';

  const formattedLastContributionDate = lastContributionDate
    ? new Date(lastContributionDate).toLocaleDateString('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
      })
    : '-';

  return (
    <Row className="g-3 mb-3">
      <Col xs={12} sm={6} xl={3}>
        <Card className="card-summary h-100">
          <CardHeader className="py-2">
            <h6 className="m-0 text-uppercase" style={{ fontSize: '0.7rem' }}>
              {t('wallet-overview.metrics.current-balance')}
            </h6>
          </CardHeader>
          <CardBody className="py-2">
            {isLoading ? (
              <div className="skeleton" style={{ height: '40px' }} />
            ) : (
              <>
                <h2 className="fw-bold mb-0" style={{ fontSize: '1.4rem', lineHeight: 1.2 }}>
                  {formatCurrency(balance)}
                </h2>
                <h6 className="fs-7 ff-secondary mb-0 text-muted" style={{ fontSize: '0.75rem' }}>
                  {t('wallet-overview.metrics.of-contribution', { percentage: balancePercentage })}
                </h6>
              </>
            )}
          </CardBody>
        </Card>
      </Col>

      <Col xs={12} sm={6} xl={3}>
        <Card className="card-summary h-100">
          <CardHeader className="py-2">
            <h6 className="m-0 text-uppercase" style={{ fontSize: '0.7rem' }}>
              {t('wallet-overview.metrics.reference-contribution')}
            </h6>
          </CardHeader>
          <CardBody className="py-2">
            {isLoading ? (
              <div className="skeleton" style={{ height: '40px' }} />
            ) : (
              <>
                <h2 className="fw-bold mb-0" style={{ fontSize: '1.4rem', lineHeight: 1.2 }}>
                  {formatCurrency(lastContributionAmount)}
                </h2>
                <h6 className="fs-7 ff-secondary mb-0 text-muted" style={{ fontSize: '0.75rem' }}>
                  {formattedLastContributionDate}
                </h6>
              </>
            )}
          </CardBody>
        </Card>
      </Col>

      <Col xs={12} sm={6} xl={3}>
        <Card className="card-summary h-100">
          <CardHeader className="py-2">
            <h6 className="m-0 text-uppercase" style={{ fontSize: '0.7rem' }}>
              {t('wallet-overview.metrics.consumed-balance')}
            </h6>
          </CardHeader>
          <CardBody className="py-2">
            {isLoading ? (
              <div className="skeleton" style={{ height: '40px' }} />
            ) : (
              <>
                <h2 className="fw-bold mb-0" style={{ fontSize: '1.4rem', lineHeight: 1.2 }}>
                  {formatCurrency(totalDebits)}
                </h2>
                <h6 className="fs-7 ff-secondary mb-0 text-muted" style={{ fontSize: '0.75rem' }}>
                  {t('wallet-overview.metrics.in-period')}
                </h6>
              </>
            )}
          </CardBody>
        </Card>
      </Col>

      <Col xs={12} sm={6} xl={3}>
        <Card className="card-summary h-100">
          <CardHeader className="py-2">
            <h6 className="m-0 text-uppercase" style={{ fontSize: '0.7rem' }}>
              {t('wallet-overview.metrics.redemptions-in-period')}
            </h6>
          </CardHeader>
          <CardBody className="py-2">
            {isLoading ? (
              <div className="skeleton" style={{ height: '40px' }} />
            ) : (
              <>
                <h2 className="fw-bold mb-0" style={{ fontSize: '1.4rem', lineHeight: 1.2 }}>
                  {debitCount}
                </h2>
                <h6 className="fs-7 ff-secondary mb-0 text-muted" style={{ fontSize: '0.75rem' }}>
                  {t('wallet-overview.metrics.in-period')}
                </h6>
              </>
            )}
          </CardBody>
        </Card>
      </Col>
    </Row>
  );
};

export default withTranslation()(WalletMetrics);
